module.exports = __webpack_public_path__ + "img/ico_gxkjyy.e4af57a0.png";